import React from "react";
import GooglePlayIcon from "../../assets/img/Group 1156.svg";
import CafeBazarIcon from "../../assets/img/Group 1157.webp";
import DriverLogo from "../../assets/img/Group 1155.svg";
import UserLogo from "../../assets/img/barnet_logo.svg";
import { setLoginStep } from "../../redux/login/login.actions";
import { useDispatch } from "react-redux";
import {
  LoginPhoneInitialStepStyled,
  UserBoxStyled,
  DriverBoxStyled,
  UserBoxBtnStyled,
  LogoContainerStyled,
  TitleStyled,
  TextStyled,
  BtnConrainerStyled,
  UserWelcomeStyled,
} from "./loginPhoneInitialStep.styles";
const LoginPhoneInitialStep = () => {
  const dispatch = useDispatch();
  const NextStep = () => {
    dispatch(setLoginStep(0));
  };
  const CafeBazar = "https://cafebazaar.ir/app/com.barman.bar.driver";
  const GooglePlay =
    " https://play.google.com/store/apps/details?id=com.barman.bar.driver";
  return (
    <LoginPhoneInitialStepStyled>
      <div className="d-flex">
        <div className="ml-2">
          <img src={UserLogo} alt="logo" />
        </div>
        <UserWelcomeStyled>
          <span style={{ fontSize: "16px", fontWeight: "999" }}>
            کاربر عزیز
          </span>
          <span style={{ fontSize: "14px", fontWeight: "999" }}>
            به بارنت خوش آمدید
          </span>
        </UserWelcomeStyled>
      </div>
      <div>
        <DriverBoxStyled>
          <div>
            <img src={DriverLogo} alt="logo" />
          </div>
          <TitleStyled>راننده هستم</TitleStyled>
          <TextStyled>
            می خواهم از بارنت برای پیدا کردن بار، برای حمل استفاده کنم
          </TextStyled>
          <LogoContainerStyled>
            <img
              className="pl-2"
              src={GooglePlayIcon}
              alt="logo"
              onClick={() => window.window.open(GooglePlay, "_blank")}
            />
            <img
              src={CafeBazarIcon}
              alt="logo"
              onClick={() => window.window.open(CafeBazar, "_blank")}
            />
          </LogoContainerStyled>
        </DriverBoxStyled>
        <UserBoxStyled>
          <div>
            <img src={UserLogo} alt="logo" />
          </div>
          <TitleStyled>صاحب بار هستم</TitleStyled>
          <TextStyled>به دنبال خودرو برای حمل بار خود هستم.</TextStyled>
          <BtnConrainerStyled>
            <UserBoxBtnStyled onClick={NextStep}>مرحله بعد</UserBoxBtnStyled>
          </BtnConrainerStyled>
        </UserBoxStyled>
      </div>
    </LoginPhoneInitialStepStyled>
  );
};

export default LoginPhoneInitialStep;
